// extracted by mini-css-extract-plugin
export default {"container":"Yd61qPUohbmhA8qUfSBF","leftSide":"v6JeuSOwfGi7ga2mdOIQ","rightSide":"OUvJp05CcO33iUX3SvVJ","title":"YhqcGl8rEwsrKTjV4Y0T","description":"ZDX5DfcKBC3aC8LI1dUv"};